import React from 'react'
import { connect } from 'react-redux'
import SectionActions from '../../Redux/SectionRedux'
import FilesActions from '../../Redux/FilesRedux'
import FileUploader from '../FileUploader'

class UpdateSectionImage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        image_file: ''
      },
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = { ...this.state.form }
      form.image_file = newProps.files.data.upload[0].filename
      this.setState({ form })
    }
  }

  _fileSelect = (event) => {
    const file = event.target
    this.setState({ file })
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'section-image')
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let uuid = this.props.detail.id
    let form = { ...this.state.form }
    const data = { uuid, form }
    this.props.submit(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section'>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Section Banner</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group text-center'>
            <label className='control-label'>Current Image</label>
            <br />
            <img style={{ maxWidth: '65vw', maxHeight: '65vh' }} alt={this.props.detail.image_file} title={this.props.detail.image_file} className='img img-responsive img-border' src={this.props.detail.image_url} />
          </div>
          <div className='form-group'>
            <div className='row'>
              <div className='col-3'>
                <label htmlFor='image' className='control-label'>Image File (<span className='text-orange'>1440x900</span>)</label>
              </div>
              <div className='col-9'>
                <FileUploader setting={{ type: 'section-image', product_type: this.state.form.product_type }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' disabled={!this.state.form.image_file} className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  submit: (data) => dispatch(SectionActions.putSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateSectionImage)



// WEBPACK FOOTER //
// ./src/Containers/Section/UpdateSectionImage.js